<template>
    <div> 
        <a-card :title="$t('edit.editActionTitles.senceMaskSets')" :bordered="false">
            <div class="sence-list">
                        <div class="list-item" v-for="(item,index) in senceList" :key="index">
                            <div class="sence-img">
                                <img :src="item.thumb_path"/>
                            </div>
                            <div class="sence-title">{{item.scene_title}}</div>
                            <div class="mask-single-box left">
                                <div class="img-con">
                                    <img
                                            v-if="item.sky_land_shade.land && item.sky_land_shade.land != ''"
                                            :src="item.sky_land_shade.land?item.sky_land_shade.land:''"
                                    />
                                    <a-icon type="file-image" class="default-icon" v-else/>
                                </div>
                                <div class="right">
                                    <div class="titles">
                                        {{$t('edit.settings.fixMap')}}
                                        <span>({{$t("descriptions.recommendSize")}}：500x500)</span>
                                    </div>
                                    <div class="btns" v-if="userInfo.level > 0 || userInfo.team_id > 0">
                                        <material-select :type="1" @selected="updateSingleLand">
                                            <template slot="body">
                                                <a-button type="primary" @click="clickSingleLand(index)">
                                                    {{$t('actionTitles.changeCover')}}
                                                </a-button>
                                            </template>
                                        </material-select>
                                        <a-button type="danger" style="margin-left: 10px" @click="deleteSingleLand(index)" v-if="item.sky_land_shade.land && item.sky_land_shade.land != ''">
                                            {{$t('actionTitles.delete')}}
                                        </a-button>
                                    </div>
                                </div>

                            </div>
                            <div class="mask-single-box">
                                <div class="img-con">
                                    <img
                                            v-if="item.sky_land_shade.sky && item.sky_land_shade.sky != ''"
                                            :src="item.sky_land_shade.sky?item.sky_land_shade.sky:''"
                                    />
                                    <a-icon type="file-image" class="default-icon" v-else/>
                                </div>
                                <div class="right">
                                    <div class="titles">
                                        {{$t('edit.settings.fixSky')}}
                                        <span>({{$t("descriptions.recommendSize")}}：500x500)</span>
                                    </div>
                                    <div class="btns" v-if="userInfo.level > 0 || userInfo.team_id > 0">
                                        <material-select :type="1" @selected="updateSingleSky">
                                            <template slot="body">
                                                <a-button type="primary" @click="clickSingleSky(index)">
                                                    {{$t('actionTitles.changeCover')}}
                                                </a-button>
                                            </template>
                                        </material-select>
                                        <a-button type="danger" style="margin-left: 10px" @click="deleteSingleSky(index)" v-if="item.sky_land_shade.sky && item.sky_land_shade.sky != ''">
                                            {{$t('actionTitles.delete')}}
                                        </a-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            <!-- <global-single @handleSubmit="saveMask" @handleCancel="cancelMask" :footer="userInfo.level > 0 || userInfo.team_id > 0" @value="$t('edit.settings.setsTitle')">
                <template v-slot:global>
                    <div class="mask-global-box">
                        <div>
                            <AdsItem
                                    :url="form.fix_logo.land"
                                    requireSize="500 x 500"
                                    :title="$t('edit.settings.fixMap')"
                                    :is-edit="userInfo.level > 0 || userInfo.team_id > 0"
                                    @updateData="updateGlobalLand"
                                    @deleteData="deleteGlobalLand"
                            ></AdsItem>
                        </div>
                        <div style="margin-left: 100px">
                            <AdsItem
                                    :url="form.fix_logo.sky"
                                    requireSize="500 x 500"
                                    :title="$t('edit.settings.fixSky')"
                                    :is-edit="userInfo.level > 0 || userInfo.team_id > 0"
                                    @updateData="updateGlobalSky"
                                    @deleteData="deleteGlobalSky"
                            ></AdsItem>
                        </div>
                    </div>
                </template>
                <template v-slot:single>
                    <div class="sence-list">
                        <div class="list-item" v-for="(item,index) in senceList" :key="index">
                            <div class="sence-img">
                                <img :src="item.thumb_path"/>
                            </div>
                            <div class="sence-title">{{item.scene_title}}</div>
                            <div class="mask-single-box left">
                                <div class="img-con">
                                    <img
                                            v-if="item.sky_land_shade.land && item.sky_land_shade.land != ''"
                                            :src="item.sky_land_shade.land?item.sky_land_shade.land:''"
                                    />
                                    <a-icon type="file-image" class="default-icon" v-else/>
                                </div>
                                <div class="right">
                                    <div class="titles">
                                        {{$t('edit.settings.fixMap')}}
                                        <span>({{$t("descriptions.recommendSize")}}：500x500)</span>
                                    </div>
                                    <div class="btns" v-if="userInfo.level > 0 || userInfo.team_id > 0">
                                        <material-select :type="1" @selected="updateSingleLand">
                                            <template slot="body">
                                                <a-button type="primary" @click="clickSingleLand(index)">
                                                    {{$t('actionTitles.changeCover')}}
                                                </a-button>
                                            </template>
                                        </material-select>
                                        <a-button type="danger" style="margin-left: 10px" @click="deleteSingleLand(index)" v-if="item.sky_land_shade.land && item.sky_land_shade.land != ''">
                                            {{$t('actionTitles.delete')}}
                                        </a-button>
                                    </div>
                                </div>

                            </div>
                            <div class="mask-single-box">
                                <div class="img-con">
                                    <img
                                            v-if="item.sky_land_shade.sky && item.sky_land_shade.sky != ''"
                                            :src="item.sky_land_shade.sky?item.sky_land_shade.sky:''"
                                    />
                                    <a-icon type="file-image" class="default-icon" v-else/>
                                </div>
                                <div class="right">
                                    <div class="titles">
                                        {{$t('edit.settings.fixSky')}}
                                        <span>({{$t("descriptions.recommendSize")}}：500x500)</span>
                                    </div>
                                    <div class="btns" v-if="userInfo.level > 0 || userInfo.team_id > 0">
                                        <material-select :type="1" @selected="updateSingleSky">
                                            <template slot="body">
                                                <a-button type="primary" @click="clickSingleSky(index)">
                                                    {{$t('actionTitles.changeCover')}}
                                                </a-button>
                                            </template>
                                        </material-select>
                                        <a-button type="danger" style="margin-left: 10px" @click="deleteSingleSky(index)" v-if="item.sky_land_shade.sky && item.sky_land_shade.sky != ''">
                                            {{$t('actionTitles.delete')}}
                                        </a-button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </template>
            </global-single> -->
            <div>
                <a-button type="primary" @click="saveMask">保存</a-button>
            </div>
        </a-card>
    </div>
</template>

<script>
    // import GlobalSingle from "./GlobalSingle";
    // import AdsItem from "./AdsItem";
    import MaterialSelect from "@/components/MaterialSelect";
    import {mapGetters, mapState} from "vuex";
    export default {
        name: "MaskView",
        components:{
            // GlobalSingle,
            // AdsItem,
            MaterialSelect},
        data(){
            return{
                form: {
                    fix_logo:{
                        land: '',
                        sky: ''
                    }
                },
                senceList:[],
                curMaskSenceId: '',
                sky_land_shade: ''
            }
        },
        computed: {
            ...mapGetters(["vrbase", "userConfig","userInfo"]),
        },
        created() {
            this.senceList = this.$deepClone(this.vrbase.scenes)
            this.form = this.$deepClone(this.vrbase.ads)
            console.log('userInfo',this.userInfo)
        },
        methods:{
            updateGlobalLand(data){
                this.form.fix_logo.land = data.url
            },
            deleteGlobalLand(){
                this.form.fix_logo.land = ''
            },
            updateGlobalSky(data){
                this.form.fix_logo.sky = data.url
            },
            deleteGlobalSky(){
                this.form.fix_logo.sky = ''
            },
            updateSingleLand(data){
                this.$set(this.senceList[this.curMaskSenceId].sky_land_shade, "land", data.url)
                console.log(this.senceList)
            },
            clickSingleLand(index){
                this.curMaskSenceId = index
            },
            deleteSingleLand(index){
                console.log(index)
                this.curMaskSenceId = index
                this.senceList[index].sky_land_shade.land = ''
            },
            updateSingleSky(data){
                this.$set(this.senceList[this.curMaskSenceId].sky_land_shade, "sky", data.url)
                console.log(this.senceList)
            },
            clickSingleSky(index){
                this.curMaskSenceId = index
            },
            deleteSingleSky(index){
                this.curMaskSenceId = index
                this.senceList[index].sky_land_shade.sky = ''
            },
            saveMask(){
                const vrbase = {...this.vrbase, ads: this.form,scenes: this.senceList}
                this.$store.dispatch("saveVRBase", {
                    vrbase,
                    showLoading: true,
                }, true);
            },
            cancelMask(){
                this.senceList = this.$deepClone(this.vrbase.scenes)
                this.form = this.$deepClone(this.vrbase.ads)
            }
        }
    }
</script>

<style lang="less" scoped>
    .mask-global-box{
        display: flex;
    }
    .list-item{
        background-color: #2f2f2f;
        border: 1px solid #555;
        padding: 20px;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .sence-img{
            width: 70px;
            height: 70px;
            flex-shrink: 0;
            img{
                width: 70px;
                height: 70px;
                object-fit: contain;
            }
        }
        .sence-title{
            flex: 1;
            margin: 0 20px;
            overflow: hidden;
            word-wrap:break-word;
        }
        .mask-single-box{
            height: 100px;
            display: flex;
            flex-shrink: 0;
            &.left{
                padding-right: 20px;
                margin-right: 20px;
                border-right: 1px dotted #555555;
            }
            .img-con{
                width: 100px;
                height: 100px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #252525;
                margin-right: 10px;
                .default-icon{
                    font-size: 24px;
                }
                img{
                    max-width: 100px;
                    max-height: 100px;
                }
            }
            .right{
                .titles{
                    margin-top: 10px;
                    span{
                        font-size: 12px;
                        color: rgba(255,255,255,.6);
                    }
                }
                .btns{
                    display: flex;
                    margin-top: 20px;
                    .changeCoverBtn {
                        background-color: #7101ad;
                        border-color: #7101ad;
                    }
                }
            }
        }
    }
    .saveBtn {
        background-color: #7101ad;
        border-color: #7101ad;
    }
</style>
